import styled from 'styled-components';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const ModalContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.defaultWhite};
  border-radius: 14px;
  width: 90%;
  max-width: 600px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
`;

export const ModalHeader = styled.div`
  padding: 24px 24px 16px 24px;
  border-bottom: 1px solid ${({ theme }) => theme.elements.primaryLight};
`;

export const HeaderText = styled.h2`
  font-size: ${({ theme }) => theme.elementFontSizes.subSectionTitle};
  color: ${({ theme }) => theme.elements.submissionHeading};
  margin: 0 0 8px 0;
  font-weight: 600;
`;

export const SubheadingText = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.small};
  color: ${({ theme }) => theme.colors.darkGrey};
  margin: 0;
`;

export const ModalBody = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const FileUploadSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const FileItemWrapper = styled.div`
  margin-top: 8px;
`;

export const ConsentSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ConsentText = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.elements.submissionHeading};
  font-size: ${({ theme }) => theme.fontSizes.medium};
  line-height: 1.5;
`;

export const ModalFooter = styled.div`
  padding: 16px 24px;
  border-top: 1px solid ${({ theme }) => theme.elements.primaryLight};
  display: flex;
  justify-content: flex-end;
  gap: 12px;
`;
